<div class="row">
  <div class="col-12 notification-list">
    <div [hidden]="loading">
      <h6>
        <span *ngIf="results.length > 0">
          {{ results.length }} of {{ totalCount }}
        </span>
        Invites
        <label *ngIf="results.length > 0" class="label label-danger">new</label>
      </h6>

      <a [hidden]="results.length === 0" [routerLink]="['/invites']">
        <invite-notification-preview
          style="margin: 0px; padding: 0px"
          *ngFor="let invite of results"
          [invite]="invite"
          [config]="config"
          [currentUser]="currentUser"
        >
        </invite-notification-preview>
      </a>
    </div>

    <!-- Loader spinner -->
    <loader-animation [loading]="loading" [message]="'Loading invites'">
    </loader-animation>
    <!-- Loader spinner -->

    <!-- No content message-->
    <no-content-msg
      [hidden]="loading || results.length"
      [message]="'No new invites'"
    >
    </no-content-msg>
    <!-- No content message -->
  </div>
</div>
